import React, { useState, useEffect } from 'react';

import WhiteColorLocation from 'Assets/SVG/OrangeLocationIcon.svg';
import locationTimeIcon from 'Assets/Icons/location-time.svg';
import locationPhoneIcon from 'Assets/Icons/location-call.svg';

import { useNavigate } from 'react-router-dom';
import CustomModal from 'Components/Modal/CustomModal';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from '../../../Redux/features/LoaderSlice';
import { setLabAddress } from '../../../Redux/features/AddressSlice';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import DefaultLocationDialog from 'Components/Dialog/DefaultLocationDialog';
import LocationChangedDialog from 'Components/Dialog/LocationChangedDialog';
import { setUserLocation } from '../../../Redux/features/LocationSlice';
import { getCityFromCoordinates, slugify } from 'Utils/Functions';
import axiosInstance from 'Utils/Interceptor';
import AvailabilityDropdown from 'Components/CommonComponents/DateAndTime/LabTiming';

const AddAddressModal = ({ show, handleCloseModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cityName, cityId, stateName, stateId, lng, lat } = useSelector(
    (state) => state.location
  );
  let citySlug = slugify(cityName);
  const [center, setCenter] = useState({ lat, lng });

  const [selectedLab, setSelectedLab] = useState();

  const [mapSearchCoordinates, setMapSearchCoordinates] = useState({
    lat: 0,
    lng: 0
  });
  const [relationList, setRelation] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [mapPosition, setMapPosition] = useState({ lat, lng });
  const [labList, setLabList] = useState([]);
  const [showLocatiomMismatchModal, setShowLocationMismatchModal] =
    useState(false);
  const [showDefaultLocationModal, setShowDefaultLocationModal] =
    useState(false);
  const { cartData } = useSelector((state) => state?.parsistStates);

  const fetchLabLocations = async (stateId) => {
    dispatch(setLoader(true));
    try {
      const { data } = await axiosInstance(
        `api/user/nearest-lab?latitude=${lat}&longitude=${lng}&city_id=${cityId}`
      );
      setLabList(data?.data);
    } catch (error) {}
    dispatch(setLoader(false));
  };

  const handlaLocationSelect = (e) => {
    dispatch(setLabAddress(e));
    setSelectedLab(e);
  };

  const handleSubmit = () => {
    navigate(`/${citySlug}/book-a-lab-visit?packages=true`);
  };

  const fetchStates = async () => {
    try {
      const { data } = await axiosInstance('/api/user/states');
      if (data) {
        const states = data.data.map((e) => ({
          label: e.state_name,
          value: e.state_id
        }));
        setRelation(states);

        stateName && setSelectedState({ label: stateName, value: stateId });
        cityName && setSelectedCity({ label: cityName, value: cityId });
      }
    } catch (error) {}
  };

  const fetchCities = async (stateId) => {
    dispatch(setLoader(true));
    try {
      const { data } = await axiosInstance(
        `/api/user/cities?state_id=${stateId}`
      );
      if (data) {
        const cities = data.data.map((e) => ({
          label: e.city_name,
          value: e.city_id
        }));
        setCityList(cities);
      }
    } catch (error) {}
    dispatch(setLoader(false));
  };

  const handleSetLocation = () => {
    setCenter(mapPosition);
    const { label: cityName } = selectedCity;
    const { label: stateName, value: stateId } = selectedState;
    dispatch(
      setUserLocation({
        cityId: selectedCity?.value,
        cityName,
        isLocation: true,
        stateId,
        stateName,
        ...mapPosition
      })
    );
  };

  const handleOpenLocationMismatchModal = () => {
    setShowLocationMismatchModal(true);
  };
  const handleCloseLocationMismatchModal = () => {
    setShowLocationMismatchModal(false);
  };

  const handleMapClick = async (lat, lng) => {
    const cityInfo = await getCityFromCoordinates(lat, lng);
    if (cityInfo) {
      const isMatch = relationList.find(
        (state) => state.label?.toLowerCase() === cityInfo.state?.toLowerCase()
      );

      if (isMatch) {
        const { data } = await axiosInstance(
          `/api/user/cities?state_id=${isMatch.value}`
        );
        if (data) {
          const city = data.data.find(
            (c) => c.city_name?.toLowerCase() === cityInfo.city?.toLowerCase()
          );
          if (city) {
            setSelectedState(isMatch);
            setSelectedCity({ label: city.city_name, value: city.city_id });
            setMapPosition({ lat, lng });
            if (cartData?.length > 0 && cityId !== city.city_id) {
              handleOpenLocationMismatchModal();
              return;
            }
            return;
          }
        }
      }
    }
    setShowDefaultLocationModal(true);
  };

  useEffect(() => {
    if (mapSearchCoordinates.lat !== 0 && mapSearchCoordinates.lng !== 0) {
      handleMapClick(mapSearchCoordinates.lat, mapSearchCoordinates.lng);
    }
  }, [mapSearchCoordinates]);

  useEffect(() => {
    fetchLabLocations();
  }, [cityId]);

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(() => {
    selectedCity && selectedCity?.value !== cityId && handleSetLocation();
  }, [selectedCity?.value]);

  useEffect(() => {
    if (selectedState) {
      fetchCities(selectedState.value);
    }
  }, [selectedState]);

  const handleDefaultLocation = () => {
    setMapPosition({ lat: 23.0225, lng: 72.5714 });
    setSelectedState({ label: 'Gujarat', value: 16 });
    setSelectedCity({ value: 1052, label: 'Ahmedabad' });
  };

  return (
    <CustomModal
      size={'xl'}
      overflow
      show={show}
      paddingNone
      removeHeader
      onClose={handleCloseModal}
    >
      <div className="">
        <div className="row">
          <div className="col-12">
            <div className="location-map-wrapper set-location">
              <div className="google-map-box">
                <div className="autocomplete-search-box">
                  <ReactGoogleAutocomplete
                    options={{
                      types: ['geocode'], // 'geocode' for comprehensive results
                      componentRestrictions: { country: 'in' },
                      fields: [
                        'address_components',
                        'geometry',
                        'formatted_address'
                      ] // Request specific
                    }}
                    onPlaceSelected={(place) => {
                      setMapSearchCoordinates({
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                      });
                    }}
                    style={{ width: '90%' }}
                    defaultValue=""
                  />
                </div>
                <GoogleMap
                  mapContainerStyle={{ width: '100%', height: '100%' }}
                  center={center}
                  zoom={13}
                  options={{
                    disableDefaultUI: true,
                    clickableIcons: false
                  }}
                >
                  {labList
                    ?.filter((lab) => lab.latitude && lab.longitude)
                    .map((lab, index) => (
                      <Marker
                        key={index}
                        position={{ lat: lab.latitude, lng: lab.longitude }}
                        title={lab.branch_name}
                      />
                    ))}
                </GoogleMap>
              </div>
              <div className="location-map-content">
                <button
                  type="button"
                  className="btn-close "
                  aria-label="Close"
                  onClick={handleCloseModal}
                ></button>
                <div className="location-map-inner-for-lab-modal">
                  {labList?.map((e, index) => (
                    <div
                      key={index}
                      className="location-map-item"
                    >
                      <div className="location-heading">
                        <div className="lab-visit-input">
                          <input
                            checked={
                              Number(selectedLab?.branch_id) === e?.branch_id
                            }
                            onChange={() => handlaLocationSelect(e)}
                            type="radio"
                            id={e?.branch_id}
                          />
                          <label for={e?.branch_id}></label>
                        </div>
                        <h4 className="">{e?.branch_name}</h4>
                        <div className="location-distance">
                          {e?.distance / 1000
                            ? (e?.distance / 1000).toFixed(2)
                            : 0}{' '}
                          km
                        </div>
                      </div>

                      <div className="location-address">
                        <figure className="location-address-icon">
                          <img
                            src={WhiteColorLocation}
                            alt=""
                          />
                        </figure>
                        <p>{e?.address}</p>
                      </div>

                      <div className="location-address">
                        <figure className="location-address-icon">
                          <img
                            src={locationPhoneIcon}
                            alt=""
                          />
                        </figure>
                        <p>{e?.contactno ? e?.contactno : '-'}</p>
                      </div>

                      <div className="location-address">
                        <figure className="location-address-icon placeholder-icon">
                          <img
                            src={locationTimeIcon}
                            alt=""
                          />
                        </figure>
                        <p>
                          {' '}
                          <AvailabilityDropdown
                            availability={e?.branch_timing}
                          />
                        </p>
                      </div>

                      <div className="form-group submit-action mt-4">
                        <button
                          onClick={handleSubmit}
                          disabled={
                            Number(selectedLab?.branch_id) !== e?.branch_id
                          }
                          type="button"
                          className="btn btn-md"
                        >
                          <span>Continue</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showLocatiomMismatchModal && (
        <LocationChangedDialog
          open={showLocatiomMismatchModal}
          handleClose={handleCloseLocationMismatchModal}
          handleDefaultLocation={handleDefaultLocation}
          handleSetLocation={handleSetLocation}
        />
      )}

      {showDefaultLocationModal && (
        <DefaultLocationDialog
          open={showDefaultLocationModal}
          handleDefaultLocation={handleDefaultLocation}
          handleClose={() => setShowDefaultLocationModal(false)}
        />
      )}
    </CustomModal>
  );
};

export default AddAddressModal;
